import axios from "axios";
import { getAuthHeader, catchApi } from "../../utils";
import { cachedGet } from "../../utils/apiResponseCache";

export const PERMISSIONS_CACHE_KEY = "rbac:permissions";
const PERMISSIONS_TTL_MS = 5 * 60_000;

export const v2_permissions = async () => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/permissions`;
    return cachedGet(
        PERMISSIONS_CACHE_KEY,
        () => catchApi(axios.get(url, getAuthHeader()).then((res) => res.data)),
        PERMISSIONS_TTL_MS
    );
};


export const v2_role_permissions = async (role_id) => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/role/permissions/${role_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_designation_permissions = async (designation_id) => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/designation/permissions/${designation_id}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v2_update_permission = async (model) => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/update-permissions`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_update_designation_permission = async (model) => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/update-designation-permissions`;
    return axios.put(url, model, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_list_approval_flows = async (module_key) => {
    const qs = module_key ? `?module_key=${encodeURIComponent(module_key)}` : "";
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/approval-flows${qs}`;
    return axios.get(url, getAuthHeader()).then((res) => res.data);
};

export const v2_replace_approval_flows = async (model) => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/approval-flows`;
    return axios.put(url, model, getAuthHeader()).then((res) => res.data);
};

export const v2_my_responsibilities = async () => {
    const url = `${(window.RUNTIME_CONFIG?.API_BASE_URL ?? "")}/v2/rbac/my-responsibilities`;
    return axios.get(url, getAuthHeader()).then((res) => res.data);
};

